import { lazy } from 'react';
import { Loadable } from '../berry/components';
import { GuestGuard } from './RouteGuards';

const Login = Loadable(lazy(() => import('../pages/Login/Login')));
const Signup = Loadable(lazy(() => import('../pages/Login/Signup')));
const Recovery = Loadable(lazy(() => import('../pages/Login/Recovery')));
// TODO FORGOT PASSWORD

const LoginRoutes = {
    path: '/',
    element: <GuestGuard />,
    children: [
        {
            path: '/login',
            element: <Login />
        },
        {
            path: '/signup/:userId/:hash', // https://app.teamstation.dev/signup?user_id=479&token=cSNNHbGEPTkmJ2K5faMfDFUKeCscpfEJV9jzBRf3tegvu
            element: <Signup />
        },
        {
            path: '/recovery/:email/:hash',
            element: <Recovery />
        }
    ]
};

export default LoginRoutes;
